<div *ngIf="icon">
  <rt-icon size="large-x" [name]="icon"></rt-icon>
</div>

<div *ngIf="imageUrl">
  <img src="{{ imageUrl }}" />
</div>

<div *ngIf="title" class="heading" [class.with-icon]="titleIcon">
  <rt-icon *ngIf="titleIcon" [name]="titleIcon" size="large"></rt-icon>
  {{ title }}
</div>

<div *ngIf="desc" class="subheading" [innerHTML]="desc"></div>

<div class="content">
  <ng-content></ng-content>
</div>
